module.exports = __webpack_public_path__ + "media/images/meet-alex-modal-1779ac3b.png";